import { useCallback, useState } from 'react';

type H = (defVal: boolean) => [boolean, () => void, () => void, () => void];

export const useBoolean: H = (defVal: boolean) => {
    const [v, setV] = useState<boolean>(defVal);
    const enabled = useCallback(() => setV(true), [setV]);
    const disabled = useCallback(() => setV(false), [setV]);
    const toggle = useCallback(() => setV((prev) => !prev), [setV]);

    return [v, enabled, disabled, toggle];
};
